import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const UploadButtonContainer = styled.div<{
  $isUploading: boolean;
  $isUploaded: boolean;
}>`
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  box-shadow: 0px 3.21px 6.27px 0px ${colors.darkBlueAlpha59};
  cursor: pointer;
  position: relative;
  border: 3px solid transparent;

  ${({ $isUploading }) =>
    $isUploading &&
    `
    border: 3px solid ${colors.lightGrayBlue};
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: -3px;
      left: -3px;
      right: -3px;
      bottom: -3px;
      border-radius: 50%;
      border: 3px solid transparent;
      border-top-color: ${colors.blue};
      border-right-color: ${colors.blue};
      animation: progressFill 2s linear forwards;
    }
  `}

  /* Success border */
  ${({ $isUploaded }) =>
    $isUploaded &&
    `
    border: 3px solid ${colors.green};
    animation: successPulse 0.6s ease-out;
  `}

  &:hover {
    background-color: ${colors.lightBlueGrayAlpha};
  }

  img {
    width: 21px;
    height: 21px;
  }

  @keyframes progressFill {
    0% {
      transform: rotate(0deg);
      border-top-color: ${colors.blue};
      border-right-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    25% {
      transform: rotate(90deg);
      border-top-color: ${colors.blue};
      border-right-color: ${colors.blue};
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    50% {
      transform: rotate(180deg);
      border-top-color: ${colors.blue};
      border-right-color: ${colors.blue};
      border-bottom-color: ${colors.blue};
      border-left-color: transparent;
    }
    75% {
      transform: rotate(270deg);
      border-top-color: ${colors.blue};
      border-right-color: ${colors.blue};
      border-bottom-color: ${colors.blue};
      border-left-color: ${colors.blue};
    }
    100% {
      transform: rotate(360deg);
      border-top-color: ${colors.blue};
      border-right-color: ${colors.blue};
      border-bottom-color: ${colors.blue};
      border-left-color: ${colors.blue};
    }
  }

  @keyframes successPulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.7);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 0 0 4px rgba(52, 199, 89, 0.3);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(52, 199, 89, 0);
    }
  }
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  top: 0;
  left: 0;
`;
